import React, { useEffect, useState } from "react";
import axios from "axios";
import { formatNumber, rateUsdt } from "../../service";

const WithdrawPage = () => {
    const [dataU, setDataU] = useState({ refOrdersAmount: 0, withdrawCommission: 0 });
    const [bankAccount, setBankAccount] = useState("");
    const [bankName, setBankName] = useState("");
    const [accountHolder, setAccountHolder] = useState("");
    const [amount, setAmount] = useState("");

    const available = (dataU.refOrdersAmount * 0.03 - dataU.withdrawCommission);

    // Auto fetch user dataU mỗi giây
    useEffect(() => {
        const interval = setInterval(() => {
            const stored = window.localStorage.getItem("userInfoActive");
            if (stored) {
                try {
                    const data = JSON.parse(stored);
                    setDataU(data);
                } catch (error) {
                    console.error("Error parsing userInfoActive:", error);
                }
            }
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    // Xử lý submit
    const handleWithdraw = async (e) => {
        e.preventDefault();

        if (!amount || !bankAccount || !accountHolder || !bankName) {
            alert("Vui lòng nhập đầy đủ thông tin");
            return;
        }

        const amt = parseFloat(amount);
        if (amt <= 0) {
            alert("Số tiền phải lớn hơn 0");
            return;
        }

        if (amt < 0.5) {
            alert("Số tiền rút tối thiểu là " + formatNumber(0.5 * rateUsdt, 0) + 'đ');
            return;
        }

        if (amt > available) {
            alert("Số tiền rút vượt quá số khả dụng!");
            return;
        }

        try {
            const token = localStorage.getItem("token");
            await axios.get("https://api7.minicorgi.xyz/user/withdraw-commission", {
                params: {
                    token,
                    amount: amt,
                    bankAccount,
                    accountHolder,
                    bankName
                }
            });

            alert("Yêu cầu đổi thưởng thành công!");
            // Reset form
            setAmount("");
            setBankAccount("");
            setAccountHolder("");
            setBankName("");
        } catch (error) {
            console.error("Withdraw failed:", error);
            alert("Đổi thưởng thất bại, vui lòng thử lại!");
        }
    };

    return (
        <div className="max-w-md mx-auto my-10 p-6 bg-white rounded-xl shadow-lg font-sans">
      <h2 className="text-center text-xl font-semibold mb-6">
        💸 Đổi thưởng
      </h2>

      {/* Số dư khả dụng */}
      <div className="text-center text-base mb-6">
        <p className="flex justify-center items-center gap-2">
          💰 Số khả dụng:{" "}
          <img src="/images/logoToken.png" alt="token" className="w-5 inline" />
          <strong>
            {formatNumber(available)} ({formatNumber(available * rateUsdt, 0)} đ)
          </strong>
        </p>
      </div>

      {/* Form */}
      <form
        onSubmit={handleWithdraw}
        className="flex flex-col gap-4"
      >
        <input
          type="text"
          placeholder="Số tài khoản ngân hàng"
          value={bankAccount}
          onChange={(e) => setBankAccount(e.target.value)}
          className="px-3 py-2 border rounded-md focus:ring-2 focus:ring-green-500 focus:outline-none"
        />
        <input
          type="text"
          placeholder="Tên chủ tài khoản"
          value={accountHolder}
          onChange={(e) => setAccountHolder(e.target.value)}
          className="px-3 py-2 border rounded-md focus:ring-2 focus:ring-green-500 focus:outline-none"
        />
        <input
          type="text"
          placeholder="Ngân hàng (VD: Vietcombank)"
          value={bankName}
          onChange={(e) => setBankName(e.target.value)}
          className="px-3 py-2 border rounded-md focus:ring-2 focus:ring-green-500 focus:outline-none"
        />

        <div className="flex gap-2">
          <input
            type="number"
            placeholder="Số tiền muốn quy đổi"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="flex-1 px-3 py-2 border rounded-md focus:ring-2 focus:ring-green-500 focus:outline-none"
          />
          <button
            type="button"
            onClick={() => setAmount(available)}
            className="px-4 py-2 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600 transition"
          >
            Max
          </button>
        </div>

        <p className="text-sm text-gray-600">
          Số tiền nhận được:{" "}
          <strong>
            {formatNumber((parseFloat(amount) || 0) * rateUsdt, 0)} đ
          </strong>
        </p>

        <button
          type="submit"
          className="w-full py-3 bg-[--color-button-3] text-white font-medium rounded-md hover:bg-green-600 transition"
        >
          Gửi yêu cầu đổi thưởng
        </button>
      </form>
    </div>
    );
};


export default WithdrawPage;
